// extracted by mini-css-extract-plugin
export default {"buttonRightIcon":"G66c3a6 G5e65f6 G5a2f5d"};